import React, { useState, useEffect } from "react";

export default function Countdown() {
    // example: next puzzle drops at midnight local time
    const nextPuzzleTime = new Date();
    nextPuzzleTime.setHours(24, 0, 0, 0);

    const [remaining, setRemaining] = useState("");

    useEffect(() => {
        function updateCountdown() {
            const now = new Date();
            const diff = nextPuzzleTime - now;

            if (diff <= 0) {
                setRemaining("Available now!");
                return;
            }

            const hours = Math.floor(diff / 1000 / 60 / 60);
            const minutes = Math.floor((diff / 1000 / 60) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            setRemaining(`${hours}h`);
        }

        updateCountdown(); // run once immediately
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={styles.box}>
            <p style={styles.label}>Next puzzle in</p>
            <p style={styles.timer}>{remaining}</p>
        </div>
    );
}

const styles = {
    box: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "1rem",
        borderRadius: "1rem",
        background: "#f0f0f0",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
    },
    label: {
        fontSize: "1rem",
        color: "#555"
    },
    timer: {
        fontSize: "2rem",
        fontWeight: "bold",
        color: "#222"
    }
};
